require('./aggregatorManageEntitiesCredentialsView.scss');

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { OKButton } from 'commonsComponents/OKButton';
import { OKLink } from 'commonsComponents/OKLink';
import { OKInput } from 'commonsComponents/OKInput';
import WizardSuccess from 'components/commons/wizardSuccess/wizardSuccess';
import WizardError from 'components/commons/wizardError/wizardError';
import { AggregatorSecondKeyAuthModal } from 'components/aggregator/aggregatorSecondKeyAuthModal/aggregatorSecondKeyAuthModal';
import AggregatorAddEntityLayout from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityLayout/aggregatorAddEntityLayout';
const { withRouter } = require('react-router-dom');

import {
    getDataBank,
    setFormValue,
    sendFormInfo,
    clearAddEntity,
    clearFormValues
} from 'actions/aggregator/aggregatorAddEntity'

import {
    sendSecondAuthKey,
    getSecondFactorAuth,
    resetSecondKeyFactorAuth
} from 'actions/aggregator/aggregatorData'

const { formatText, FormattedText } = require('core/i18n').i18n;
import {
    recordPath,
    PROC_INSERT_OTP_PAGE,
    PROC_INSERT_OTP_PROCESS,
    PROC_INSERT_OTP_SUCCESS_PAGE,
    PROC_INSERT_OTP_SUCCESS_STEP,
    PROC_INSERT_OTP_ERROR_PAGE,
    PROC_INSERT_OTP_ERROR_STEP,
    PROC_STEP
} from 'utilities/tagging';

class AggregatorManageEntitiesCredentialsViewClass extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            inputValue: '',
            showKeyModal: false
        }
    }

    componentDidMount() {
        recordPath(PROC_INSERT_OTP_PAGE, '', PROC_INSERT_OTP_PROCESS, `${PROC_STEP}1`)
    }

    componentWillUnmount() {
        const { resetSecondKeyFactorAuth } = this.props;
        resetSecondKeyFactorAuth();
    }

    getMappingBreadcrumb() {
        return [{
            text: formatText('breadcrumb-global'),
            url: '/myprofile/global'
        },
        {
            text: formatText('breadcrumb-aggregatorSettingsPG'),
            url: '/myprofile/global/entities/manage'
        }, {
            text: formatText('breadcrumb-entitiesCredentials'),
            url: ''
        }]
    }

    handleOnAccept = () => {
        const { inputValue } = this.state;
        const { bank, sendSecondAuthKey } = this.props;

        sendSecondAuthKey(inputValue, bank.get('userBankId'), bank.get('code'))
    }

    handleWizardErrorDidMountCallback = () => {
        recordPath(PROC_INSERT_OTP_ERROR_PAGE, '', PROC_INSERT_OTP_PROCESS, PROC_INSERT_OTP_ERROR_STEP)
    }

    renderError() {
        return (
            <WizardError
                errorMessage={formatText('aggregatorManageEntities-errorTitle')}
                errorSubMessage={formatText('aggregatorManageEntities-errorSubTitle')}
                customClassName="aggregator-credentials-view__wizard__wizard-step-login__form__form__wizard-error"
                mainButton={
                    {
                        label: formatText('aggregatorManageEntities-mainButton'),
                        url: '/myprofile/global',
                    }
                }
                secondaryButton={{
                    label: formatText('aggregatorManageEntities-secondaryButton'),
                    url: '/myprofile/global',
                    modifier: 'link-complementary'
                }}
                onComponentDidMountCallback={this.handleWizardErrorDidMountCallback}
            >
                <p>
                    {formatText('aggregatorManageEntities-errorMessage')}
                </p>
            </WizardError>
        )
    }

    handleWizardSuccessDidMountCallback = () => {
        recordPath(PROC_INSERT_OTP_SUCCESS_PAGE, '', PROC_INSERT_OTP_PROCESS, PROC_INSERT_OTP_SUCCESS_STEP)
    }

    renderSuccesful() {
        const { bank } = this.props;
        const bankName = bank ? bank.get('name') : '';
        const bankLogoUrl = bank ? bank.get('imageUrl') : '';

        const mainButton = {
            label: formatText('aggregatorManageEntitiesSuccess-secondaryButton'),
            url: '/myprofile/global',
            modifier: 'link-complementary'
        }

        return (
            <div className="aggregator-credentials-view__confirm-success-step col-xs-12">
                <WizardSuccess
                    successMessage={<FormattedText value="aggregatorManageEntitiesSuccess-title" injectedStrings={[bankName]} />}
                    mainButton={mainButton}
                    onComponentDidMountCallback={this.handleWizardSuccessDidMountCallback}
                >
                    <p>
                        <FormattedText value="aggregatorManageEntitiesSuccess-text" injectedStrings={[bankName]} />
                    </p>
                    <img className="aggregator-credentials-view__confirm-success-step__img" src={bankLogoUrl} />
                </WizardSuccess>
            </div>
        );
    }

    onHandleShowModalKeyModal = (sendNewKey = false) => {
        const { showKeyModal } = this.state;
        const { bank, getSecondFactorAuth } = this.props;

        if (sendNewKey) getSecondFactorAuth(bank.get('userBankId'));

        this.setState({
            showKeyModal: !showKeyModal
        })
    }

    renderContent() {
        const { inputValue } = this.state;
        const { bank, fetchingSecondKeyAuth, errorSecondKeyAuth, successSecondKeyAuth } = this.props;

        if (errorSecondKeyAuth) return this.renderError();
        if (successSecondKeyAuth) return this.renderSuccesful();

        return (
            <div className="aggregator-credentials-entities-view__form">
                <img src={bank.get('imageUrl')} alt={bank.get('name')} />
                <p className="aggregator-credentials-entities-view__form__description">
                    <FormattedText value="aggregatorCredentials-titleDescription" injectedStrings={[bank.get('name')]} />
                </p>
                <div className="aggregator-credentials-entities-view__form__input-container">
                    <div className="aggregator-credentials-entities-view__form__input-container__input">
                        <OKInput
                            value={inputValue}
                            label={<FormattedText value="aggregatorCredentials-labelInput" />}
                            onChange={(event) => this.setState({ inputValue: event.target.value })}
                        />
                    </div>
                    <OKButton
                        onClick={() => this.onHandleShowModalKeyModal()}
                        modifier="link-complementary"
                    >
                        <FormattedText value="aggregatorCredentials-getCodeButton" />
                    </OKButton>
                </div>
                <footer className="aggregator-credentials-view__buttons row">
                    <div className="aggregator-credentials-view__buttons__left col-xs-6">
                        <OKLink
                            modifier="emphasize"
                            to="/myprofile/global/entities/manage"
                        >
                            <FormattedText value="aggregatorCredentials-back" />
                        </OKLink>
                    </div>
                    <div className="aggregator-credentials-view__buttons__right col-xs-6">
                        <OKButton
                            disabled={inputValue.length === 0}
                            modifier="primary"
                            onClick={this.handleOnAccept}
                            loading={fetchingSecondKeyAuth}
                        >
                            <FormattedText value="aggregatorCredentials-confirmButton" />
                        </OKButton>
                    </div>
                </footer>
            </div>
        )
    }

    render() {
        const { showKeyModal } = this.state;

        return (
            <div>
                <AggregatorAddEntityLayout
                    title={formatText('aggregatorManageEntities-title')}
                    breadCrumb={this.getMappingBreadcrumb()}
                    showInfoColumn={true}
                >
                    {this.renderContent()}
                </AggregatorAddEntityLayout>
                <AggregatorSecondKeyAuthModal
                    callBack={this.onHandleShowModalKeyModal}
                    showKeyModal={showKeyModal}
                />
            </div>
        )
    }
}

AggregatorManageEntitiesCredentialsViewClass.propTypes = {
    immAggregatorAddEntity: PropTypes.object,
    bank: PropTypes.object,
    clearAddEntity: PropTypes.func,
    getDataBank: PropTypes.func,
    sendFormInfo: PropTypes.func,
    setFormValue: PropTypes.func,
    clearFormValues: PropTypes.func,
    fetchingSecondKeyAuth: PropTypes.bool,
    resetSecondKeyFactorAuth: PropTypes.func,
    getSecondFactorAuth: PropTypes.func,
    sendSecondAuthKey: PropTypes.func,
    errorSecondKeyAuth: PropTypes.bool,
    successSecondKeyAuth: PropTypes.bool,
    match: PropTypes.shape({
        params: PropTypes.shape({
            bankId: PropTypes.string
        }),
    }),
}

const AggregatorManageEntitiesCredentialsView = connect(
    (state, ownProps) => ({
        immAggregatorAddEntity: state.aggregatorAddEntity,
        bank: state.aggregatorData.getIn(['data', 'banks', ownProps.match.params.bankId]),
        fetchingSecondKeyAuth: state.aggregatorData.get('isFetchingSecondKeyAuth'),
        errorSecondKeyAuth: state.aggregatorData.get('errorSecondKeyAuth'),
        successSecondKeyAuth: state.aggregatorData.get('succesSecondKeyAuth'),
    }), {
    sendFormInfo,
    getDataBank,
    setFormValue,
    clearAddEntity,
    clearFormValues,
    sendSecondAuthKey,
    getSecondFactorAuth,
    resetSecondKeyFactorAuth
}
)(withRouter(AggregatorManageEntitiesCredentialsViewClass))

module.exports.constructor = AggregatorManageEntitiesCredentialsView;
module.exports.AggregatorManageEntitiesCredentialsView = AggregatorManageEntitiesCredentialsView
